import Vue from 'vue'
import Vuex from 'vuex'
import app from '@/store/modules/app'
import cart from '@/store/modules/cart'
import user from '@/store/modules/user'

const getters = {
  is_login: state => state.user.is_login,
  token: state => state.user.token,
  expires_in: state => state.user.expires_in,
  userInfo: state => state.user.userInfo,
  tenant_id: state => state.app.tenant_id,
  appInfo: state => state.app.appInfo,
  chatInfo: state => state.app.chatInfo,
}

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    app,
    cart,
    user
  },
  getters
})
export default store;
